export const POST_LOGIN_SUCCESS = 'POST_LOGIN_SUCCESS';
export const WECHAT_LOGIN_SUCCESS = 'WECHAT_LOGIN_SUCCESS';
export const WECHAT_BIND_SUCCESS = 'WECHAT_BIND_SUCCESS';

export const CHECK_LOGIN_QRCODE_SUCCESS = 'CHECK_LOGIN_QRCODE_SUCCESS';
export const SET_QRCODE_STATUS = 'SET_QRCODE_STATUS';
export const SET_WECHAT_LOGIN_DATA = 'SET_WECHAT_LOGIN_DATA';

export const LOADING_MESSAGE = '请稍等...';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
export const GET_IM_TOKEN_SUCCESS = 'GET_IM_TOKEN_SUCCESS';
